import { lazy, Suspense } from "react"
import { Environment } from "@react-three/drei"
import { CuboidCollider, Physics, RigidBody } from '@react-three/rapier'

// Lazy-load: r3f-perf serve solo in ?debug → import dinamico, così
// webpack lo separa dal bundle principale e i visitatori non lo scaricano
const Perf = lazy(() => import("r3f-perf").then((m) => ({ default: m.Perf })))

import { useControls } from "leva"

import '../../style.css'
import { DEBUG_MODE } from '../../config/debug'
import Player from './Player'
import { MainModel, PlantsParkingSpotModel, GlassModel } from './ModelsHandler'
import ProductsHandler from './ProductsHandler'
import CartFlux from './CartFlux'
import ProductShowcase from './ProductShowcase'
import ProductMediaOrbit from './ProductMediaOrbit'
import Billboard from './Billboard'
import Cassa from './Cassa'
import Gumball from './Gumball'
import { useStore, statoGumballStore } from '../../store/uiStore'

export default function Experience() {
  // La macchinetta sta sul bancone SEMPRE: e' arredamento, e un bancone col
  // buco dove dovrebbe esserci e' peggio di una macchinetta spenta. Che poi ci
  // si possa giocare lo dice `funziona` (vedi Hud e config/gumball.js).
  const gumball = useStore(statoGumballStore).visibile
  const r = 'environmentMaps/'
  const urls = [
    r + 'px.jpg', r + 'nx.jpg',
    r + 'py.jpg', r + 'ny.jpg',
    r + 'pz.jpg', r + 'nz.jpg'
  ]

  const {debugCollision} = useControls({debugCollision: false})
  
  return <>

    {/* Statistiche performance solo in modalità debug (?debug nell'URL) */}
    {DEBUG_MODE && (
      <Suspense fallback={null}>
        <Perf position='top-left' />
      </Suspense>
    )}

    <Environment background files={urls} />

    <Physics debug={debugCollision} >
      <RigidBody type='fixed'>
        //Edificio
        <CuboidCollider args={[11.2, 0.15, 11.2]} position={[0, -0.02, 0]} />//Pavimento
        <CuboidCollider args={[3.34, 0.15, 11.2]} rotation={[0, 0, Math.PI / 2]} position={[-11.2, 3.34, 0]} /> //muro Nord
        <CuboidCollider args={[3.34, 0.1, 11.2]} rotation={[0, 0, Math.PI / 2]} position={[+11.3, 3.34, 0]} /> //muro Sud
        <CuboidCollider args={[3.34, 0.1, 11.2]} rotation={[0, Math.PI / 2, Math.PI / 2]} position={[0, 3.34, -11.3]} /> //muro Est
        <CuboidCollider args={[3.34, 0.1, 11.2]} rotation={[0, Math.PI / 2, Math.PI / 2]} position={[0, 3.34, +11.12]} /> //muro Ovest
        //Scaffali
        <CuboidCollider args={[3.39, 1.935, 1.28]} position={[-6.91, 1.935, -5.53]} /> //scaffale 1
        <CuboidCollider args={[3.39, 1.935, 1.28]} rotation={[0, Math.PI / 2, 0]} position={[-6.92, 1.935, 7.174]} /> //scaffale 2
        <CuboidCollider args={[3.39, 1.935, 1.28]} rotation={[0, Math.PI / 2, 0]} position={[-1.16, 1.935, 7.174]} /> //scaffale 3
        //Bancone
        <CuboidCollider args={[2.03, .99, .87]} position={[3.83, .99, -.25]} />
        <CuboidCollider args={[4.8, .99, .8]} position={[6.6, .99, -5.46]} />
        <CuboidCollider args={[1.8, .99, .85]} rotation={[0, Math.PI / 2, 0]} position={[2.65, .99, -2.9]} />
        //Pilastro
        <CuboidCollider args={[.42, 3.34, .42]} position={[6.3, 3.34, +1.02]} />
      </RigidBody>
      <Player />
    </Physics>
    <MainModel />
    <PlantsParkingSpotModel />
    <GlassModel />
    <ProductsHandler />
    <CartFlux />
    <ProductShowcase />
    <ProductMediaOrbit />
    <Billboard />
    <Cassa />
    {gumball && <Gumball />}
  </>
}
